import { collection, Firestore, getFirestore, limit, onSnapshot, orderBy, query } from "firebase/firestore";
import { FirebaseAuth } from "./firebaseauth";
import { map, Observable } from "rxjs";
import { FirebaseApp } from "firebase/app"; // USA QUESTO
import { MLLog } from "mlng";

export interface FirebasePortalSystemKey {
    id?: string;
    value: string;
    createdAt?: any; // Timestamp Firebase
}

export class FirebasePortal {

    private _fs!: Firestore;
    private _fauth!: FirebaseAuth;

    public constructor(app: FirebaseApp, fauth: FirebaseAuth) {
        //this._auth = getFirestore(app);
        this._fs = getFirestore(app);
        this._fauth = fauth;
    }

    getLatestKey(): Observable<FirebasePortalSystemKey | undefined> {
        const keysRef = collection(this._fs, 'system', 'global', 'keys');
        const q = query(keysRef, orderBy('createdAt', 'desc'), limit(1));
        return new Observable<FirebasePortalSystemKey | undefined>(
            sub => {
                return onSnapshot(q,
                    snap => {
                        const d = snap.docs[0];
                        sub.next(d ? ({ id: d.id, ...(d.data() as any) }) : undefined);
                    },
                    err => {
                        MLLog.logError("FirebasePortal error", err)
                        sub.error(err)
                    }
                );
            }
        );
    }
}